//import { SignalRService } from './signalr.service';
//import { MySignalReceiver } from './SignalReceiver';
import DCApp from './../../Views/Shared/App.vue';
import * as Vue from 'vue';
import { createPinia } from 'pinia';

/*export class UserInfo {
    public iduser: number = 0;
    public username: string = "";
    public isconfirmed: boolean = false;
    public email: string = "";
    public groupe: number = 0;
    public hash: string = "";
    public locale: string = "";
    public datecreation!: Date;
}

export class LoginResult {
    public token: string = "";
    public urlProfil: string = "";
    public isadmin: boolean = false;
    public userinfo: UserInfo | null = null;
}

export enum RequestState {
    Failed = -1,
    NotAuth = 0,
    Success = 1
}

export class RequestResult {
    public state: RequestState | null = null;
    public msg: string = "";
    public data: LoginResult | null = null;
    public versionajour: boolean = true;
}


export class ExternalProvider {
    public name: string = "";
    public displayname: string = "";
}

export class LoginModalView {
    public m_err: boolean = false;
    public loginreturnurl: string = "";
    public m_listeprovider: ExternalProvider[] = [];
}*/



export class DCMain {
    //private signalr: SignalRService = new SignalRService();
    public constructor() {


    }

    public InitVue() {
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.mount('#rootpage');
    }

   /* public InitSignalR() {
        this.signalr.RegisterNotifier(new MySignalReceiver());
        this.signalr.InitSignalR();
    }

    public DestroySignalR() {
        this.signalr.RegisterNotifier(null);
        this.signalr.DestroySignalR();
    }*/
}

(<any>(window)).DCMain = function () { return new DCMain(); };
